import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotifierConnectionStatus, NotifierState } from "./types";

const initialState: NotifierState = {
  socketId: null,
  lastMessageTimestamp: Date.now(),
  connectionStatus: NotifierConnectionStatus.DISCONNECTED,
};

const notifierSlice = createSlice({
  name: "notifier",
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<NotifierConnectionStatus>) => {
      state.connectionStatus = action.payload;
    },

  },
});

export const { setConnectionStatus } = notifierSlice.actions;
export default notifierSlice.reducer;

// Re-export NotifierState for backward compatibility
export type { NotifierState };
